import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Mapa from "../Maps/Mapa";
import MapLot from "../Maps/MapLot";
import lotService from "../../services/lot-service";

const MenuLines = () => {
  const [title, setTitle] = useState("Finca - Lote");

  const [lotId, setLotId] = useState()
  const [lotName, setLotName] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const farm_name = localStorage.getItem("farmName");
    const lot_name = localStorage.getItem("lotName");
    const lot_id = localStorage.getItem("lotId");
    setLotId(lot_id)
    setLotName(lot_name)
    setTitle(`Finca: ${farm_name} - ${lot_name}`);
  }, []);






    const generateExcel = async () => {
    setLoading(true);
    try {
      console.log(lotId)
      const response = await lotService.getPalmsLot(lotId);
      if (response?.error) {
        //toast.error("No hay registros", { autoClose: 1600 })
        setLoading(false);
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `linea palma ${lotName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }




  return (
    <div className="row px-3 pt-3 pb-3 ">

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Administrar lote - {title}</Divider>
      </div>




      <div className="col-12 ms-2 mb-4">
        <Link to="/admin-lots" className="nav-link link-primary p-1">
          <i className="bi bi-arrow-left-short fa-lg"></i>
          <span className="fs-6 m-1">
            <strong>REGRESAR</strong>
          </span>
        </Link>
      </div>


      <div className="col-5">
        <div className="row">

          <div className="col-12">
            <div className="card mb-3" >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">Crear lineas y palmas Excel</h5>
                    <p className="card-text">Ingresa las palmas y sus coordenadas desde excel.</p>
                    <p className="card-text">
                      <Link to="/create-lines-palms-excel" className="nav-link ">
                        <button className="btn btn-success  w-50">
                          <i className="bi bi-upload m-2"></i>
                          Subir excel palmas
                        </button>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div className="col-12">
            <div className="card mb-3" >
              <div className="row g-0">
               
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-secondary"> Actualizar coordenadas excel</h5>
                    <p className="card-text">Actualiza las coordenadas de la palmas desde excel.</p>
                    <p className="card-text">
                      <Link to="/update-coordinates-excel" className="nav-link ">
                        <button className="btn btn-success w-50">
                          <i className="bi bi-upload m-2"></i>
                          Subir excel
                        </button>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>




          <div className="col-12">
            <div className="card mb-3" >
              <div className="row g-0">
               
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-secondary"> Descargar palmas</h5>
                    <p className="card-text">Descarga las palmas con sus coordenadas en formato Excel.</p>
                    <p className="card-text">
                      
                        <button className="btn btn-primary w-50" onClick={generateExcel}>
                          <i className="bi bi-download fa-lg m-2" />
                          Descargar Palmas
                        </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>




        </div>
      </div>


    </div>
  );
};

export default MenuLines;
